var path = '/modal/tpl/window.html';
var html = "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\" aria-labelledby=modal-title aria-describedby=modal-description aria-modal=true> <div class=modal-content uib-modal-transclude></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/modal/tpl/window.html
// module id = 1135
// module chunks = 7